import type { Options } from '#netzo/shared/types/core'
import type { File, Option } from '#netzo/shared/types/db'
import { createId } from '#netzo/utils/core/db'
import { merge } from 'es-toolkit/compat'

export const getDefaultPricelistitem = (data: Partial<Pricelistitem>) => {
  return merge({
    id: createId(), // IMPORTANT: cloudflare throws error if called on global scope
    currency: defaultAppVariables.currency,
    tags: [],
    data: getDefaultPricelistitemData(data?.data ?? {}),
  }, data)
}

export const optionsPricelistitems = {
  currency: optionsShared.currency,
} satisfies Options

export const optionsPricelistitemsMap = {
  Moneda: optionsPricelistitems.currency,
}

export const relationsPricelistitems: Record<string, boolean> = {
  pricelist: true,
  productitem: true,
  serviceitem: true,
  files: true,
  // options: true,
}

export type PricelistitemWithRelations = Pricelistitem & {
  pricelist: Pricelist
  productitem: Productitem
  serviceitem: Serviceitem
  files: File[]
  options: Option[]
}

export const viewSettingsPricelistitems: ViewSettings = {
  tableName: 'pricelistitems',
  typeOptions: optionsShared.views.filter(view => ['grid'].includes(view.value)),
  type: 'grid',
  pagination: { page: 1, pageSize: 25 },
  paginationOptions: optionsShared.page,
  compact: true,
  columns: [
    {
      key: 'select',
      class: 'text-center', // for <th>
      rowClass: 'text-center', // for <td>
    },
    {
      key: 'actions',
      disabled: true,
      class: 'text-center', // for <th>
      rowClass: 'text-center', // for <td>
    },
    {
      key: 'item.name',
      label: 'Item',
      sortable: false,
    },
    {
      key: 'item.sku',
      label: 'SKU',
      class: 'text-center', // for <th>
      rowClass: 'text-center', // for <td>
    },
    {
      key: 'item.image',
      label: 'Imágen',
      class: 'min-w-[150px] max-w-[300px] overflow-x-auto',
    },
    {
      key: 'currency',
      label: 'Moneda',
      sortable: true,
      class: 'text-center', // for <th>
      rowClass: 'text-center', // for <td>
    },
    {
      key: 'basePrice',
      label: 'Precio U',
      sortable: true,
    },
    {
      key: 'item.fiscalData.satUnitKey',
      label: 'Unidad (SAT)',
      sortable: true,
      class: 'text-center', // for <th>
      rowClass: 'text-center', // for <td>
    },
    {
      key: 'pricelist.name',
      label: 'Lista de precios',
      sortable: true,
    },
    {
      key: 'pricelist.type',
      label: 'Tipo de Lista',
      sortable: true,
      class: 'text-center', // for <th>
      rowClass: 'text-center', // for <td>
    },
    {
      key: 'pricelist.status',
      label: 'Estado lista',
      sortable: true,
      class: 'text-center', // for <th>
      rowClass: 'text-center', // for <td>
    },
    {
      key: 'pricelist.date',
      label: 'Fecha lista',
      sortable: true,
      class: 'text-center', // for <th>
      rowClass: 'text-center', // for <td>
    },
    {
      key: 'tags',
      label: 'Etiquetas',
    },
    {
      key: 'files',
      label: 'Archivos',
      class: 'max-w-[300px] overflow-x-auto',
    },
    ...COLUMNS_METADATA,
  ],
}
